import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  constructor() {}

  showNotification(message: string): void {
    this.notificationSubject.next(message);
  }

  hideNotification(): void {
    this.notificationSubject.next(null);
  }

  getNotification(): Observable<string | null> {
    return this.notificationSubject.asObservable();
  }
}